import { createSlice } from "@reduxjs/toolkit";
import { UIInterface } from "@typing/types";
import { set } from "lodash";

const initialState: UIInterface = { 
  sort: "",
  sortBy: "",
};

const uiSlice = createSlice({
  name: "uiData",
  initialState,
  reducers: {
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setSortBy: (state, action) => {
      state.sortBy = action.payload;
    }
  },
});

export const { setSort, setSortBy } = uiSlice.actions;
export default uiSlice.reducer;
